import { Link, Typography } from "@mui/material"

export const Questions = [
  'What Web Browser do I need to access MYBCMEA?',
  'How do I get an account?',
  'Why do I need an account?',
  'How do I get information regarding dispatch (shift times, process, etc.)?',
  'Forgot your password?',
  'Need technical assistance?',
  'Need help using the MYBCMEA?',
  'How do I change my Password?',
  'I have popup blockers, would the MYBCMEA site function properly?',
  'Why are my existing MYBCMEA bookmarks not working?',
  'How to access information about my payroll and benefits?',
  'How to safely access MYBCMEA from a public computer?',
  'How to join BCMEA?'
]

export const Answers = [
  'All recent major browsers. Examples: Microsoft Edge, Google Chrome, Apple Safari',
  'Please call Dispatch Admin at: 604-251-6141',
  'MYBCMEA contains private information. Employee Number and Password are used to protect this information!',
  (<Typography>Please call Dispatch Admin at: 604-251-6141, or review the <Link target='_blank' onClick={() => window.open('/assets/documents/dispatch_brochure.pdf')}>Vancouver Dispatch Brochure</Link></Typography>),
  'Please contact MYBCMEA password reset line at 604-251-6141',
  'Please contact MYBCMEA technical support line at 604-251-6141',
  'Please contact MYBCMEA technical support line at 604-251-6141',
  'Tap on your initials icon (top-right) to access your profile page. Once there, you can tap on the "UPDATE MYBCMEA PASSWORD" and/or "UPDATE IVR PASSWORD" options under the Profile Security section',
  'Some MYBCMEA pages will use popup. Some popup blockers may prevent the content to not display properly. We have not tested MYBCMEA with popup blockers and do not support such software',
  'MYBCMEA has been modernized and redesigned. You will need to re-bookmark the new pages',
  (<Typography>
    From the MYBCMEA Welcome Page, tap on <Link href='/benefits-links' target='_blank'>Benefits Links</Link>, or you can contact ADP or WEBC directly:
    <br />- ADP: 1-888-207-0727
    <br />- WEBC: 604-689-7184
  </Typography>),
  (<Typography>For your information security and safety when using a public computer, we recommend the following:
    <br />- Don't allow the machine to save your password
    <br />- Logout from MYBCMEA immediately after you are done
    <br />- Clear the browser cache before you leave</Typography>),
  'You can start by contacting our head office at: 604-688-1155'
]